import { render, staticRenderFns } from "./ProductScenarios.vue?vue&type=template&id=0d5516a5&scoped=true"
import script from "./ProductScenarios.vue?vue&type=script&lang=js"
export * from "./ProductScenarios.vue?vue&type=script&lang=js"
import style0 from "./ProductScenarios.vue?vue&type=style&index=0&id=0d5516a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5516a5",
  null
  
)

export default component.exports